import React, { useState, useEffect } from "react"
import PropTypes from 'prop-types'
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"

//i18n
import { withTranslation } from "react-i18next"
// Redux
import { connect } from "react-redux"
import { withRouter, Link } from "react-router-dom"

// users
import user4 from "../../../assets/images/users/avatar-1.jpg"

const ProfileMenu = props => {
  // Declare a new state variable, which we'll call "menu"
  const [menu, setMenu] = useState(false);
  const { user } = props;

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item waves-effect"
          id="page-header-user-dropdown"
          tag="button"
        >
          <img
            className="rounded-circle header-profile-user"
            src={user?.profile_picture ? user?.profile_picture : require('../../../assets/images/logo-sm.png')}
            alt="Header Avatar"
            style={{ objectFit: 'cover' }}
          />{" "}
          <span className="d-none d-xl-inline-block ms-1">{user?.name}</span>{" "}
          <i className="mdi mdi-chevron-down d-none d-xl-inline-block"></i>{" "}
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          <Link to="/booking">
            <DropdownItem tag="a">
              {" "}
              <i className="mdi mdi-calendar-check font-size-16 align-middle me-1"></i>{" "}
              {props.t("Booking")}{" "}
            </DropdownItem>
          </Link>
          <Link to="/slot">
            <DropdownItem tag="a">
              {/* <span className="badge bg-success float-end">11</span> */}
              <i className="mdi mdi-calendar-clock font-size-16 align-middle me-1"></i>{" "}
              {props.t("Slot")}
            </DropdownItem>
          </Link>
          <Link to="/users">
            <DropdownItem tag="a">
              {/* <span className="badge bg-success float-end">11</span> */}
              <i className="mdi mdi-account-circle-outline font-size-16 align-middle me-1"></i>{" "}
              {props.t("Patient")}
            </DropdownItem>
          </Link>
          <Link to="/notice">
            <DropdownItem tag="a">
              <i className="mdi mdi-bulletin-board font-size-16 align-middle me-1"></i>{" "}
              {props.t("Notice")}
            </DropdownItem>
          </Link>
          <div className="dropdown-divider" />
          <Link to="/logout" className="dropdown-item text-danger">
            <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger"></i>{" "}
            <span>{props.t("Logout")}</span>
          </Link>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  )
}

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any
}

const mapStatetoProps = state => {
  const { error, success, user } = state.Profile
  return { error, success, user }
}

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(ProfileMenu))
)